export default "__VITE_ASSET__DaJwKXRg__"